module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<td>\r\n    <input type="text" id="titulo_transmitente" class="form-control" value="'+
((__t=(attributes.titulo_transmitente))==null?'':_.escape(__t))+
'" '+
((__t=(disabled))==null?'':_.escape(__t))+
'/>\r\n</td>\r\n<td>\r\n    <div class="input-group" id="dtpickerfechaTitulo">\r\n        <input type=\'text\' id="titulo_fecha" class="form-control date" value="'+
((__t=(attributes.titulo_fecha))==null?'':_.escape(__t))+
'" '+
((__t=(disabled))==null?'':_.escape(__t))+
' />\r\n        <span class="input-group-addon">\r\n            <span class="glyphicon glyphicon-calendar"></span>\r\n        </span>\r\n    </div>\r\n</td>\r\n<td>\r\n    <input type="text" id="titulo_publico" class="form-control" value="'+
((__t=(attributes.titulo_publico))==null?'':_.escape(__t))+
'" '+
((__t=(disabled))==null?'':_.escape(__t))+
' />\r\n</td>\r\n<td>\r\n    <input type="text" id="titulo_notario" class="form-control" value="'+
((__t=(attributes.titulo_notario))==null?'':_.escape(__t))+
'" '+
((__t=(disabled))==null?'':_.escape(__t))+
' />\r\n</td>\r\n<td>\r\n    <input type="text" id="titulo_concepto" class="form-control" '+
((__t=(disabled))==null?'':_.escape(__t))+
' value="'+
((__t=(attributes.titulo_concepto))==null?'':_.escape(__t))+
'"/>\r\n</td>\r\n\r\n<td>\r\n    <input type="text" id="titulo_protocolo" class="form-control number" '+
((__t=(disabled))==null?'':_.escape(__t))+
' value="'+
((__t=(attributes.titulo_protocolo))==null?'':_.escape(__t))+
'"/>\r\n</td>\r\n\r\n<td>\r\n    <div class="form-group inputField">\r\n            <div class="input-icon input-icon-right">\r\n                    <i>€</i>\r\n                    <input type="text" placeholder="0,00" id="titulo_valor" class="form-control money text-right" value="'+
((__t=( attributes.titulo_valor ))==null?'':_.escape(__t))+
'"  '+
((__t=( disabled ))==null?'':_.escape(__t))+
' />\r\n            </div> \r\n    </div>\r\n</td>\r\n<td>\r\n    <div class="unbreakable"><span class="ion ion-ios-close text-red remove" aria-label="Remove"></span></div>\r\n</td>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/views/goodsDetail/sections/titulos.ejs
// module id = 159
// module chunks = 0